import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export default {
  name: "city-master",
  components: {},
  data: function data() {
    return {
      list: [{
        miniDevNum: 0,
        maxDevNum: 4,
        miniRetention: "0%",
        maxRetention: "100%",
        settlementRatio: "0%"
      }, {
        miniDevNum: 5,
        maxDevNum: 9,
        miniRetention: "0%",
        maxRetention: "90%",
        settlementRatio: "0%"
      }, {
        miniDevNum: 5,
        maxDevNum: 9,
        miniRetention: "90%",
        maxRetention: "100%",
        settlementRatio: "100%"
      }, {
        miniDevNum: 10,
        maxDevNum: 99999,
        miniRetention: "0%",
        maxRetention: "49.9%",
        settlementRatio: "0%"
      }, {
        miniDevNum: 10,
        maxDevNum: 99999,
        miniRetention: "50%",
        maxRetention: "79.9%",
        settlementRatio: "85%"
      }, {
        miniDevNum: 10,
        maxDevNum: 99999,
        miniRetention: "80%",
        maxRetention: "100%",
        settlementRatio: "100%"
      }]
    };
  },
  mounted: function mounted() {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {}
};